import React from "react";
import { Button, Modal } from "react-bootstrap";
import "./../Success.css";
import { withRouter } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import Pagination from "react-js-pagination";
import { attemptGetHeadquartersList } from "../../../redux/actions/indexActions";
import { connect } from "react-redux";
import UpdateHeadquartersModal from "./UpdateHeadquartersModal";
import DeleteHeadquartersModal from "./../Headquarters/DeleteHeadquartersModal";
import CreateHeadquartersModal from "./../Headquarters/CreateHeadquartersModal";
class HeadquartersModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activePage: 1,
      page: 1,
      isSuccessModalOpened: false,
      ID: null,

      isShowDeleteBlock: false,
      isShowEditBlock: false,
      isShowCreateBlock: false,
      isSwEditBlock: false
    };
  }

  close = () => {
    this.setState({
      isShowDeleteBlock: false,
      isSuccessModalOpened: false
    });
  };

  componentDidMount() {
    const { page } = this.state;
    const { language } = this.props;
    this.props.attemptGetHeadquartersList(language, 4, page);
  }

  handlePageChange(pageNumber) {
    this.setState({ activePage: pageNumber }, () => {
      this.props.attemptGetHeadquartersList(this.props.language, 4, pageNumber);
    });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      this.state.countPerPage !== prevState.countPerPage ||
      this.state.page !== prevState.page
    ) {
      this.props.attemptGetHeadquartersList(
        this.props.language,
        4,
        this.state.page
      );
    }
  }

  deleteArticle = id => {
    fetch(process.env.REACT_APP_API_URL + `/admin/headquarter/` + id, {
      method: "delete",
      headers: {
        Authorization: `token ${localStorage.getItem("accessToken")}`,
        "Content-Type": "application/x-www-form-urlencoded"
      }
    })
      .then(res => {
        this.props.attemptGetHeadquartersList(this.props.language, 5, 1);
        this.setState({ isSuccessModalOpened: true, activePage: 1 });
      })
      .catch(err => console.log(err));
    this.setState({ isShowEditBlock: false });
  };

  render() {
    const { headquartersList } = this.props;
    return (
      <Modal
        {...this.props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="false"
      >
        <Modal.Body>
          {!this.state.isShowEditBlock ? <h4>Headquarters</h4> : null}

          <div className="container">
            <table className="table">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">Name</th>
                  <th scope="col">Edit</th>
                  <th scope="col">Delete</th>
                </tr>
              </thead>
              <tbody>
                {headquartersList &&
                  headquartersList.list.length &&
                  headquartersList.list.map((item, index) => {
                    return (
                      <tr>
                        <th scope="row">{index+1+(this.state.activePage-1)*this.state.countPerPage}</th>
                        <td>{item.name}</td>
                        <td>
                          <div
                            onClick={() => {
                              this.setState({
                                isSwEditBlock: true,
                                ID: item.id
                              });
                            }}
                          >
                            <FontAwesomeIcon icon={faEdit} />
                          </div>
                        </td>
                        <td>
                          <div
                            onClick={() =>
                              this.setState({
                                isShowDeleteBlock: true,
                                ID: item.id
                              })
                            }
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </div>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
            {headquartersList && headquartersList.list.length > 0 ? (
              <div>
                <Pagination
                  activePage={this.state.activePage}
                  itemsCountPerPage={4}
                  totalItemsCount={headquartersList.count}
                  pageRangeDisplayed={4}
                  onChange={e => this.handlePageChange(e)}
                />
              </div>
            ) : null}
            <UpdateHeadquartersModal
              show={this.state.isSwEditBlock}
              onHide={() => {
                this.setState({ isSwEditBlock: false });
              }}
              id={this.state.ID}
              isSuccessModalOpened={this.state.isSuccessModalOpened}
            />
            <CreateHeadquartersModal
              show={this.state.isShowCreateBlock}
              onHide={() => {
                this.setState({ isShowCreateBlock: false });
              }}
              isSuccessModalOpened={this.state.isSuccessModalOpened}
            />
            <DeleteHeadquartersModal
              show={this.state.isShowDeleteBlock}
              onsend={() => this.deleteArticle(this.state.ID)}
              onHide={() => {
                this.setState({ isShowDeleteBlock: false });
              }}
              isSuccessModalOpened={this.state.isSuccessModalOpened}
              closemodal={this.close}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          {!this.state.isShowEditBlock ? (
            <>
              <Button onClick={this.props.onHide}>Close</Button>
              <Button
                onClick={() => this.setState({ isShowCreateBlock: true })}
              >
                Add new
              </Button>
            </>
          ) : null}
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = store => {
  return {
    headquartersList: store.headquartersList,
    language: store.language
  };
};

function mapDispatchToProps(dispatch) {
  return {
    attemptGetHeadquartersList: (lang, countPerPage, page) =>
      dispatch(attemptGetHeadquartersList(lang, countPerPage, page))
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(HeadquartersModal));
